import React, { useEffect, useState } from "react";

const PHASES = [
  "Scanning demand signals...",
  "Finding who is already making money...",
  "Checking saturation...",
  "Pulling proof and earnings...",
  "Synthesizing the report...",
];

export default function CyclingLoader() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % PHASES.length), 2400);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="flex flex-col items-center justify-center gap-8 py-12" data-testid="cycling-loader">
      <div className="relative w-32 h-32 flex items-center justify-center">
        <svg width="128" height="128" viewBox="0 0 128 128" className="absolute inset-0">
          <defs>
            <linearGradient id="loaderGrad" x1="0" x2="1" y1="0" y2="0">
              <stop offset="0%" stopColor="#4ADE80" stopOpacity="0" />
              <stop offset="100%" stopColor="#4ADE80" />
            </linearGradient>
          </defs>
          <circle cx="64" cy="64" r="54" stroke="#1a221c" strokeWidth="3" fill="none" />
          <circle
            cx="64"
            cy="64"
            r="54"
            stroke="url(#loaderGrad)"
            strokeWidth="3"
            fill="none"
            strokeLinecap="round"
            strokeDasharray="120 339"
            style={{ transformOrigin: "64px 64px", animation: "gl-spin 1.6s linear infinite" }}
          />
        </svg>
        <div className="font-bold text-[#4ADE80] tabular-nums leading-none" style={{ fontSize: 28 }}>
          {Math.round(((idx + 1) / PHASES.length) * 100)}
          <span className="text-sm font-light text-[#4ADE80]/70 ml-0.5 align-top">%</span>
        </div>
      </div>
      <div className="text-center min-h-[3rem]">
        <div className="gl-label mb-2">Researching</div>
        <div
          key={idx}
          className="text-lg sm:text-xl text-white font-medium gl-fade-up"
          data-testid="loader-phase-text"
        >
          {PHASES[idx]}
        </div>
      </div>
      <style>{`@keyframes gl-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
